/**
 * The IDL of the module.
 *
 * @module
 */
/** The IDL of the module. */
export const idl = {
  module_id: "0x1::transaction_context",
  functions: [],
  structs: [],
  errors: {},
} as const;
